import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function mentalDisorderValidator(control: FormGroup): ValidationErrors | null {
    const mentalDisorder = control.value.hasMentalDisorder;
    const mentalDisorderDescription = control.value.mentalDisorderDescription;
    return mentalDisorder && !mentalDisorderDescription ? { "mentalDisorderDescriptionMissing": true } : null;
}